import { Tag } from 'lucide-react'
import { useState } from 'react'

import { useGetTagsForBrokerage } from '../../hooks/needs_attention/useGetTagsForBrokerage'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterGroup,
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import {
  filterByLabelAndExactValueCallback,
  getTagFilterOptions,
} from './utils'

const TagFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data: tags } = useGetTagsForBrokerage()

  const options: ComboboxFilterGroup<string>[] = getTagFilterOptions(tags)

  const tagOptions: ComboboxFilterOption<string>[] =
    tags?.map((tag) => ({
      label: tag.name,
      value: tag.id,
    })) || []

  const filteredOptions = options?.map((group) => ({
    ...group,
    options: group.options.filter(filterByLabelAndExactValueCallback(query)),
  }))

  const filteredOptionsIncludingUntagged = [
    { groupLabel: 'Pinned', options: [...props.defaultPinnedOptions || []] },
    ...filteredOptions,
  ]

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={filteredOptionsIncludingUntagged}
        placeholder='Search tags to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={[...props.defaultPinnedOptions || [], ...tagOptions]}
          noSelectionText='Tag'
          pluralIdentifier='tags'
        >
          <Tag size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default TagFilter
